"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAUSE_AFTER_INACTIVITY_IN_MINUTES = exports.UPDATE_STUDY_TIME_INTERVAL_IN_SECONDS = exports.StudyTimeAction = exports.StudyTimeRecordDateFormat = void 0;
exports.StudyTimeRecordDateFormat = 'yyyy-MM-dd';
var StudyTimeAction;
(function (StudyTimeAction) {
    StudyTimeAction["HEARTBEAT"] = "HEARTBEAT";
    StudyTimeAction["PAUSE_TIMER"] = "PAUSE_TIMER";
    StudyTimeAction["PLAY_TIMER"] = "PLAY_TIMER";
    StudyTimeAction["REVERSE_HEARTBEATS"] = "REVERSE_HEARTBEATS";
})(StudyTimeAction || (exports.StudyTimeAction = StudyTimeAction = {}));
exports.UPDATE_STUDY_TIME_INTERVAL_IN_SECONDS = 60;
exports.PAUSE_AFTER_INACTIVITY_IN_MINUTES = 15;
//# sourceMappingURL=types.js.map